import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeroSm, MyInput, NavBar } from "../../components";
import { Footer } from "../../layouts";
import Loader from "../../components/loader";
import { Slang } from "../../helpers";
import config from "../../config";
import { toast } from "react-toastify";
import { fetchWrapper } from "../../helpers/fetch-wrapper";
import Spinner from "../../components/spinner";
import axios from "axios";
import { useSelector } from "react-redux";

// token in all function

const MailSent = ({ forgotPassword }) => {
  const [loadPage, setLoadPage] = useState(true);
  useEffect(() => {
    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim1);
    };
  }, []);
  return (
    <>{loadPage ? <Loader /> : <Main forgotPassword={forgotPassword} />}</>
  );
};

export default MailSent;

const Main = ({ forgotPassword = false }) => {
  const lang = Slang("emailVerification");
  const errLang = Slang("emailVerified");
  const [canSubmit, setCanSubmit] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [endPoint, setEndPoint] = useState(
    config.apiUrl + "/user/activate-account"
  );
  const [data, setData] = useState({
    validationCode: "",
  });
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmit(true);

    // console.log('*******************bonjour******************');

    
    console.log("token", token);

    axios
      .post(
        endPoint,
        {
          pin: parseInt(data.validationCode),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("response submitted", response);

        const redirection = forgotPassword
          ? "/update-password"
          : "/verify-email-success";
        navigate(redirection);
      })
      .catch((e) => {
        setSubmit(false);
      });

    // fetchWrapper
    //   .post(endPoint, {
    //     pin: parseInt(data.validationCode),
    //   },)
    //   .then((response) => {
    //     const redirection = forgotPassword ? "/update-password" : "/verify-email-success";
    //     navigate(redirection);
    //   })
    //   .catch((e) => {
    //     setSubmit(false);
    //   });
  };

  useEffect(() => {
    if (forgotPassword) {
      setEndPoint(config.apiUrl + "/user/active-code");
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    value.length === 6 ? setCanSubmit(true) : setCanSubmit(false);
    setData({ ...data, [name]: value });
  };

  const handleResend = () => {
    console.log("*****************yoyo******************");

    const token = sessionStorage.getItem("token");
    if (!token) return;

    console.log("*****************yoyo******************", token);
  
    const answer = window.confirm("Voulez-vous vraiment renvoyer le code ?");
    if (!answer) return;
  
    axios.post(`${config.apiUrl}/resent/user/activation_code`,{}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      console.log("message", response.data.message);
      toast.info(errLang("t3"));
    })
    .catch((e) => {
      console.error("error", e);
    });

    // fetchWrapper
    //   .post(`${config.apiUrl}/resent/user/activation_code`,)
    //   .then((response) => {
    //     console.log("message", response.data.message);
    //     toast.info(errLang("t3"));
    //   })
    //   .catch((e) => {});
  };
  return (
    <>
      <NavBar />
      <HeroSm title={lang("title")} />
      <main id="content" role="main" className="my-sm-5 my-md-0">
        <section>
          <div className="container content-space-t-lg-1 content-space-b-lg-3">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card border">
                  <div className="card-body">
                    <h4 className="card-title">{lang("t1")}</h4>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="validationCode" className="form-label">
                          {lang("t2")}
                        </label>
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="validationCode"
                          name="validationCode"
                          placeholder={lang("t3")}
                          type="number"
                        />
                      </div>
                      <button
                        disabled={submit ? submit && canSubmit : !canSubmit}
                        type="submit"
                        className="btn btn-primary"
                      >
                        {submit ? <Spinner color="light" /> : lang("t4")}
                      </button>
                    </form>
                    <div className="d-flex align-content-center mt-3">
                      <span className="mr-1">{lang("t5")}</span>
                      <button
                        onClick={handleResend}
                        className="btn btn-link p-0"
                      >
                        {lang("t6")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};
